import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ServicesSection } from './components/ServicesSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { AboutSection } from './components/AboutSection';
import { GallerySection } from './components/GallerySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { LoadingScreen } from './components/LoadingScreen';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { ServiceAgreement } from './components/ServiceAgreement';
import { TermsOfService } from './components/TermsOfService';
import { ChatWidget } from './components/ChatWidget';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ProblemSection />
      <ServicesSection />
      <PricingSection />
      <FaqSection />
      <AboutSection />
      <GallerySection />
      <ContactSection />
    </>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Disable scroll during loading
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isLoading]);

  return (
    <HelmetProvider>
      <div className="App bg-[#0a0a0a] min-h-screen" data-testid="app-container">
        <BrowserRouter>
          {/* Loading Screen */}
          {isLoading && <LoadingScreen onComplete={() => setIsLoading(false)} />}

          {/* Main Content */}
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/service-agreement" element={<ServiceAgreement />} />
              <Route path="/terms" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
          
          {/* Chat Widget - appears on all pages */}
          <ChatWidget />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
